import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { ISubscribeConfig } from '../config';
var SubscribeService = /** @class */ (function () {
    function SubscribeService(http, config) {
        this.http = http;
        this.config = config;
    }
    SubscribeService.prototype.subscribe = function (data) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.post(this.config.api + "/NewsletterApi/subscribe", data).toPromise()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return SubscribeService;
}());
export { SubscribeService };
